import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; 
import dashboardReducer from '../Components/Pages/DashboardTabs/DashboardSlice';

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["dashboard"], // only persist dashboard slice
}

const persistedDashboardReducer = persistReducer(persistConfig, dashboardReducer);

export const store = configureStore({
  reducer: {
    dashboard: persistedDashboardReducer,
    
  },
});

export const persistor = persistStore(store);